module.exports = __webpack_public_path__ + "img/1.3934e902.png";